<template>
	<div class="text-center pa-4">
		<v-dialog v-model="activeDialog" transition="dialog-bottom-transition" fullscreen>
			<v-card>
				<v-toolbar>
					<v-toolbar-title>Settings</v-toolbar-title>
					<v-toolbar-items>
						<v-btn prepend-icon="mdi-close" @click="closeSettings">Close</v-btn>
					</v-toolbar-items>
				</v-toolbar>

				<v-list>
					<v-item-group v-model="selectedTheme">
						<v-container>
							<v-row>
								<v-col v-for="t in themes" :key="t.name" cols="12" md="4">
									<v-item :value="t">
										<v-card>
											<v-img @click="toggleTheme(t)" :src="t.img" style="max-height: var(--moe-space-24);" />
											<v-card-title class="d-none d-md-flex">
												{{ t.name }}
												<span v-if="selectedTheme.name === t.name"> (x)</span>
											</v-card-title>
										</v-card>
									</v-item>
								</v-col>
							</v-row>
						</v-container>
					</v-item-group>
				</v-list>
			</v-card>
		</v-dialog>
	</div>
</template>

<script setup lang="ts">
import { ref, watch, defineProps, defineEmits } from 'vue';
import { useTheme } from 'vuetify';
import { useAppStore } from '@/stores/app.store';
import lightModeSvg from '@/assets/img/lightMode.svg';
import darkModeSvg from '@/assets/img/darkMode.svg';
import useSystemSvg from '@/assets/img/useSystem.svg';
import MBtn from '@/components/BaseButton.vue';

const props = defineProps<{ isActive: boolean }>();
const emit = defineEmits<{ (e: 'closed'): void }>();

const activeDialog = ref(props.isActive);
const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

const themes = [
	{ name: 'light', img: lightModeSvg },
	{ name: 'dark', img: darkModeSvg },
	{ name: 'system', img: useSystemSvg }
] as const;

const theme = useTheme();
const appStore = useAppStore();

const selectedTheme = ref(
	themes.find((t) => t.name === appStore.getTheme) ?? themes[0]
);

function closeSettings() {
	activeDialog.value = false;
	emit('closed');
}

function toggleTheme(selection: typeof themes[number]) {
	theme.global.name.value =
		selection.name === 'system'
			? prefersDarkMode
				? 'dark'
				: 'light'
			: selection.name;
	appStore.setTheme(selection.name);
	selectedTheme.value = selection;
}

watch(
	() => props.isActive,
	(newVal) => {
		activeDialog.value = newVal;
	}
);
</script>

<style scoped>
/* Add your component styles here */
</style>
 
